import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true)); }, [slug]);

  if (notFound) return <div className="py-32 text-center text-[#8C7B6E]">Post not found. <Link to="/blog" className="text-[#D4AF37]">Back to Journal</Link></div>;
  if (!post) return <div className="py-32 text-center text-[#8C7B6E]"><Loader2 className="animate-spin inline" /></div>;

  return (
    <article data-testid="blog-post" className="max-w-3xl mx-auto px-4 sm:px-8 py-14">
      <Link to="/blog" className="flex items-center gap-1 text-[#8C7B6E] text-sm hover:text-[#D4AF37] mb-8"><ArrowLeft size={14} /> Back to Journal</Link>
      <span className="eyebrow">{post.author}</span>
      <h1 className="font-display text-4xl sm:text-5xl mt-3 leading-tight">{post.title}</h1>
      <img src={post.cover_image} alt={post.title} className="w-full aspect-[16/9] object-cover rounded-2xl mt-8" />
      <p className="text-[#C8B8AB] text-lg leading-relaxed mt-8 whitespace-pre-line">{post.content}</p>
    </article>
  );
}
